import { Lightbulb, Timer, ShieldCheck } from "lucide-react";
import { Card } from "./ui/card";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "./ui/hover-card";

export const KeyBenefits = () => {
  const benefits = [
    {
      Icon: Lightbulb,
      title: "Smarter Response",
      description: "Step-by-step, protocol-aligned prompting designed with expert clinician input and presented for clinician review.",
      hoverTitle: "AI-Powered Decision Support",
      hoverDescription: "Models are developed with expert clinician review and configured to institutional protocols. Training-data volumes and model performance are not published pending verification, and the system supports — never replaces — clinician decision-making.",
    },
    {
      Icon: Timer,
      title: "Support for Time-Critical Steps",
      description: "Designed to reduce hesitation around timing of defibrillation, medication steps, and airway management during Code Blue events. Not yet demonstrated in clinical use.",
      hoverTitle: "Time-Critical Interventions",
      hoverDescription: "Resuscitation guidelines emphasize minimizing delays to CPR and defibrillation (American Heart Association, 2020 Guidelines for CPR and ECC, Circulation 2020;142(16_suppl_2)). datasyteAI™ is designed to present clear, timely prompts; it has not been shown to change survival.",
    },
    {
      Icon: ShieldCheck,
      title: "Quantum Security",
      description: "Preparing for Q-Day with a roadmap toward quantum-resistant cryptography.",
      hoverTitle: "Future-Proof Security",
      hoverDescription: "Post-quantum cryptography adoption is an engineering objective in progress, not a completed or certified capability, and is not a guarantee of future security outcomes.",
    },
  ];

  return (
    <section className="py-16" id="key-benefits">
      <div className="container mx-auto px-6">
        <div className="eyebrow eyebrow-dot mb-4 reveal">Why it matters</div>
        <h2 className="section-title mb-3 reveal">Key Benefits</h2>
        <p className="text-muted-foreground mb-8 reveal">
          Design goals for AiMediQ™ powered by datasyteAI™, which is in the pre-market development and validation phase: not FDA cleared or approved, and not for clinical use or sale.
        </p>
        <div className="grid md:grid-cols-3 gap-7">
          {benefits.map((benefit, index) => (
            <HoverCard key={index} openDelay={200} closeDelay={100}>
              <HoverCardTrigger asChild>
                <Card className="reveal p-6 hover:-translate-y-2 transition-transform duration-300 bg-secondary/50 cursor-pointer">
                  {/* Same icon treatment as the desktop CapabilityCard. */}
                  <span className="mb-3 inline-flex size-10 items-center justify-center rounded-lg border border-border bg-surface text-primary">
                    <benefit.Icon className="size-5" aria-hidden="true" />
                  </span>
                  <h3 className="text-xl font-bold mb-2">{benefit.title}</h3>
                  <p className="text-muted-foreground">{benefit.description}</p>
                </Card>
              </HoverCardTrigger>
              <HoverCardContent className="w-80 bg-card/95 backdrop-blur-sm border-primary/20">
                <div className="space-y-2">
                  <h4 className="text-sm font-semibold text-primary">{benefit.hoverTitle}</h4>
                  <p className="text-sm text-muted-foreground">{benefit.hoverDescription}</p>
                </div>
              </HoverCardContent>
            </HoverCard>
          ))}
        </div>
      </div>
    </section>
  );
};
